import React from 'react';
import { Input, Form, Button, Space } from 'antd';
import { MobileOutlined, SafetyOutlined } from '@ant-design/icons';
import { phoneRules, verifyCodeRules } from '../utils/validation';

/**
 * 手机登录表单组件
 * 使用验证工具函数优化代码
 */
const PhoneLoginForm = React.memo(() => {
  return (
    <div>
      <div className='flex flex-col w-full'>
        <span className='text-base text-slate-800 mb-2'>手机号</span>
        <Form.Item
          name="phone"
          rules={phoneRules}
        >
          <Input 
            size="large" 
            placeholder="请输入手机号" 
            className="rounded-lg w-full" 
          />
        </Form.Item>
      </div>
      <div className='flex flex-col w-full'>
        <span className='text-base text-slate-800 mb-2'>验证码</span>
        <Space.Compact style={{ width: '100%' }}>
          <Form.Item
            name="verifyCode"
            noStyle
            rules={verifyCodeRules}
            style={{ width: '100%' }}
          >
            <Input 
              size='large' 
              placeholder="请输入验证码" 
              maxLength={6}
              className="rounded-l-lg w-full" 
            />
          </Form.Item>
          <Button 
            size='large' 
            type="primary"
            className='min-w-[120px] rounded-r-lg'
          >
            获取验证码
          </Button>
        </Space.Compact>
      </div>
    </div>
  );
});

PhoneLoginForm.displayName = 'PhoneLoginForm';

export default PhoneLoginForm;